import { render, staticRenderFns } from "./ColorChips.vue?vue&type=template&id=6e0fc363"
import script from "./ColorChips.vue?vue&type=script&lang=ts"
export * from "./ColorChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports